import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 bg-white border-t border-gray-100" data-id="element-51">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-52">
        <div className="flex flex-col md:flex-row items-center gap-8 bg-green-50 p-8 rounded-2xl border border-green-100" data-id="element-53">
          <div className="flex-shrink-0" data-id="element-54">
            <ShieldCheck className="w-24 h-24 text-green-600" data-id="element-55" />
          </div>
          <div data-id="element-56">
            <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-57">
              Garantía de Satisfacción de 7 Días
            </h3>
            <p className="text-gray-700 leading-relaxed" data-id="element-58">
              Estamos tan seguros de que PACK INGLÉS LISTO™ va a transformar tu
              forma de trabajar que te damos 7 días para probarlo. Si sentís que
              no te ahorra tiempo o no es lo que esperabas, te devolvemos el
              100% de tu dinero. Sin preguntas. El riesgo es todo nuestro.
            </p>
          </div>
        </div>
      </div>
    </section>;
}